import { state } from '../actions/store';

export const getPageArticles = (prop, page) => {
  return state.articles[prop].items.slice(0, page).reduce((result, pageChunk) => {
    pageChunk.forEach(article => result.push(article));
    return result;
  }, []);
};

export const getArticlesPage = prop => {
  return state.articles[prop].page;
};
